import { store } from "../store/store";
import { CSR_CATEGORIES } from "../config/permissions.config";

export const getRole = () => {
  try {
    const state = store.getState();
    return state.role?.currentRole ?? null;
  } catch (err) {
    return null;
  }
};

export const getLabRole = () => {
  try {
    const state = store.getState();
    return state.role?.labRole ?? null;
  } catch (err) {
    return null;
  }
};

export const getPartnerCategory = () => {
  try {
    const state = store.getState();
    return state.role?.category ?? null;
  } catch (err) {
    return null;
  }
};

export const hasPartnerCategory = (...categories) => {
  const role = getRole();
  if (role !== "PARTNER" && role !== "TEAM_MEMBER") return false;
  const category = getPartnerCategory();
  return Boolean(category) && categories.includes(category);
};

export const isCsrPartner = () => hasPartnerCategory(...CSR_CATEGORIES);

/** Normalize lab role from JWT / DB for comparisons */
export const normalizeLabRole = (role) => {
  if (role == null) return "";
  return String(role).trim();
};

/** True when lab role is Lead (case-insensitive) */
export const isLabLeadRole = (labRole) => normalizeLabRole(labRole).toLowerCase() === "lead";

export const isLabLead = () => isLabLeadRole(getLabRole());

/** SUPPORT user who appears on the lab crew roster with any role */
export const isLabCrewMember = () => Boolean(normalizeLabRole(getLabRole()));

/**
 * Who may add / activate / deactivate / delete crew roster entries:
 * - Active Lab Lead, or
 * - SUPPORT user not on the crew roster (admin bootstrap — can add the first Lead).
 */
export const canManageLabCrewRoster = ({ loginRole, labRole } = {}) => {
  const lr = loginRole !== undefined ? loginRole : getRole();
  const lab = labRole !== undefined ? labRole : getLabRole();
  if (lr !== "SUPPORT") return false;
  if (isLabLeadRole(lab)) return true;
  if (!normalizeLabRole(lab)) return true;
  return false;
};

/**
 * Lab Tech / QA Specialist: personal portal only (no roster management UI).
 */
export const isLabCrewPortalOnly = ({ loginRole, labRole } = {}) => {
  const lr = loginRole !== undefined ? loginRole : getRole();
  const lab = labRole !== undefined ? labRole : getLabRole();
  if (lr !== "SUPPORT") return false;
  if (!normalizeLabRole(lab)) return false;
  return !isLabLeadRole(lab);
};
